"use strict";

const isProductionEnvironment = process.env.NODE_ENV === "production";
const apiUrl = isProductionEnvironment
  ? "https://api.hebammeroth.de"
  : "http://localhost:14011";
const token = localStorage.getItem("token");

export default {
  apiUrl: apiUrl,
  isProduction: isProductionEnvironment,
  token: token
};
